export const GET_USER_FOLDERS_REQUEST = "GET_USER_FOLDERS_REQUEST";
export const GET_USER_FOLDERS_SUCCESS = "GET_USER_FOLDERS_SUCCESS";
export const GET_USER_FOLDERS_FAIL = "GET_USER_FOLDERS_FAIL";

export const GET_ONE_USER_FOLDER_REQUEST = "GET_ONE_USER_FOLDER_REQUEST";
export const GET_ONE_USER_FOLDER_SUCCESS = "GET_ONE_USER_FOLDER_SUCCESS";
export const GET_ONE_USER_FOLDER_FAIL = "GET_ONE_USER_FOLDER_FAIL";

export const CREATE_USER_FOLDER_REQUEST = "CREATE_USER_FOLDER_REQUEST";
export const CREATE_USER_FOLDER_SUCCESS = "CREATE_USER_FOLDER_SUCCESS";
export const CREATE_USER_FOLDER_FAIL = "CREATE_USER_FOLDER_FAIL";

export const UPDATE_USER_FOLDER_REQUEST = "UPDATE_USER_FOLDER_REQUEST";
export const UPDATE_USER_FOLDER_SUCCESS = "UPDATE_USER_FOLDER_SUCCESS";
export const UPDATE_USER_FOLDER_FAIL = "UPDATE_USER_FOLDER_FAIL";

export const DELETE_USER_FOLDER_REQUEST = "DELETE_USER_FOLDER_REQUEST";
export const DELETE_USER_FOLDER_SUCCESS = "DELETE_USER_FOLDER_SUCCESS";
export const DELETE_USER_FOLDER_FAIL = "DELETE_USER_FOLDER_FAIL";

export const ATTACH_PRODUCT_REQUEST = "ATTACH_PRODUCT_REQUEST";
export const ATTACH_PRODUCT_SUCCESS = "ATTACH_PRODUCT_SUCCESS";
export const ATTACH_PRODUCT_FAIL = "ATTACH_PRODUCT_FAIL";

export const DETACH_PRODUCT_REQUEST = "DETACH_PRODUCT_REQUEST";
export const DETACH_PRODUCT_SUCCESS = "DETACH_PRODUCT_SUCCESS";
export const DETACH_PRODUCT_FAIL = "DETACH_PRODUCT_FAIL";
